import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { VendorService } from '../shared/vendor.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InstructionsComponent } from '../instructions/instructions.component';
import { ProgressBarService } from '../shared/progress-bar.service';
import { Subscription } from 'rxjs';
import { ConfirmationComponent } from '../shared/components/confirmation/confirmation.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-additional-involved-parties',
  templateUrl: './additional-involved-parties.component.html',
  styleUrls: ['./additional-involved-parties.component.css', '../shared/css/common.css']
})
export class AdditionalInvlovedPartiesComponent implements OnInit {
  isformloaded: boolean = false;
  instructionText!: string | null;
  isInstruction: boolean = false;
  isFormsValid: boolean = false;

  payorkey: number;
  isMember = false;
  profileMasterTypeKey: any;
  isExternalReferringParty: string = "";
  primaryColor?: string = "";
  involvedPartyControl: any;
  editInvolvedPartyControl: any;
  anotherInvolvedPartyControl: any;
  externalInvolvedPartyControl: any;
  additionalInvolvedPartyControl: any;
  involvedPartyFormPart = this.formBuilder.group({});
  editInvolvedPartyFormPart = this.formBuilder.group({});
  anotherInvolvedPartyFormPart = this.formBuilder.group({});
  externalInvolvedPartyFormPart = this.formBuilder.group({});
  additionalInvolvedPartyFormPart = this.formBuilder.group({});
  involvedPartyList: any = [];
  primaryInvolveParty: any;
  providerDetails: any;
  memberDetails: any;
  nonEnumeratedProviderDetails: any;
  nonEnumeratedOrganizationDetails: any;
  nonEnumeratedIndividualDetails: any;
  resetInvolvedPartiesControls: any = [];
  childFormValid: boolean = false;
  childFormChanged: boolean = false;
  addAnotherInvolvedParty: string = '';
  involvedPartyTypeSelected: boolean = false;
  private dataSubscription!: Subscription;
  subjecyTypeId: any;
  showSaveButton: boolean = false;
  currentInvolvedPartyTypeData: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private vendorService: VendorService,
    private cdref: ChangeDetectorRef,
    private modalService: NgbModal,
    private progressBarService: ProgressBarService,
    private modalBSService: BsModalService, 
  ) {
    this.payorkey = parseInt(sessionStorage.getItem("payorkey") ?? "0");
  }

  formdata: any | null;

  ngOnInit(): void {
    this.formdata = this.vendorService.getSessionData();
    this.providerDetails = JSON.parse(JSON.stringify(this.formdata.providerDetails));
    this.memberDetails = JSON.parse(JSON.stringify(this.formdata.memberDetails));
    this.nonEnumeratedProviderDetails = JSON.parse(JSON.stringify(this.formdata.nonEnumeratedProviderDetails));
    this.nonEnumeratedOrganizationDetails = JSON.parse(JSON.stringify(this.formdata.nonEnumeratedOrganizationDetails));
    this.nonEnumeratedIndividualDetails = JSON.parse(JSON.stringify(this.formdata.nonEnumeratedIndividualDetails));
    this.resetInvolvedPartiesControls = JSON.parse(JSON.stringify(this.formdata.involvedParties.controls));
    this.anotherInvolvedPartyControl = this.formdata.involvedParties.controls.slice(0, 1);
    this.primaryInvolveParty = this.formdata.involvedParties.data.find((item: any) => item.isPrimary == true);
    this.involvedPartyList = this.formdata.involvedParties.data.filter((item: any) => item.isPrimary == false);
    this.involvedPartyControl = this.formdata.involvedParties.controls.slice(1,2);
    this.externalInvolvedPartyControl = this.formdata.involvedParties.controls.slice(2,3);
    this.additionalInvolvedPartyControl = this.formdata.involvedParties.controls.slice(3,5);
    this.formdata.involvedParties.controls.forEach((element: any) => {
      element.value = '';
    });
    this.isExternalReferringParty = '';
    this.addAnotherInvolvedParty = '';
    this.involvedPartyTypeSelected = false;

    //this.addAnotherInvolvedParty = this.formdata.involvedParties.controls.find((x: { name: string; }) => x.name == "isAnotherInvolvedParty").value;
    this.vendorService.getLeadHeaders(this.payorkey).subscribe((result) => {
      this.isInstruction = result.IsInstructionEnbaled;
      let instructionText = result.Instruction;
      instructionText = instructionText.replace('<img ', '<img title="Header" ')
      this.instructionText = instructionText;
    });
    this.loadPartiesInvolved();
    this.formValidate();
    this.dataSubscription = this.vendorService.getFormData().subscribe((data: any) => {
      this.formdata = data;
    });

    this.editInvolvedPartyControl = [{
      "name": "editInvolvedType",
      "label": "Please select the involved party type",
      "value": "",
      "type": "select",
      "options": [
        {
            "key": "Member",
            "value": "Member"
        },
        {
          "key": "Provider",
          "value": "Provider"
        },
        {
          "key": "Participant",
          "value": "Participant"
        }
      ],
      "validators": {
        "required": true
      }
    }]
  }

  loadPartiesInvolved() {
    this.vendorService.getInvolvedPartiesLookup(this.payorkey).subscribe((result) => {

      let selectedpartyId = this.involvedPartyControl.find((x: { name: string; }) => x.name == "additionalInvolvedType").value;
      if (!selectedpartyId) {
        this.involvedPartyControl.find((x: { name: string; }) => x.name == "additionalInvolvedType").options = result.map(x => { return { "value": x.Id, "key": x.Title } });
        this.editInvolvedPartyControl.find((x: { name: string; }) => x.name == "editInvolvedType").options = result.map(x => { return { "value": x.Id, "key": x.Title } });
      }
      let selectedparty = result.find(x => x.Id == selectedpartyId);
      if (selectedparty) {
        this.profileMasterTypeKey = selectedparty.ProfileMasterTypeKey;
        this.subjecyTypeId = selectedparty.SubjectTypeKey;
        this.cdref.detectChanges();
      }
    });

    setTimeout(() => {
      if (localStorage.getItem('primaryCssColor') != null && typeof (localStorage.getItem('primaryCssColor')) != 'undefined') {
        const colorFromStorage = localStorage.getItem('primaryCssColor');
        this.primaryColor = colorFromStorage ? colorFromStorage.toString() : '';
        document.documentElement.style.setProperty('--primary-color', this.primaryColor);
      }
    }, 0);
  }

  back() {
    if(this.isFormsValid) {
      window.sessionStorage.setItem("AdditionalInvolvedPartyFormValid", "true");
    }
    else {
      window.sessionStorage.removeItem("AdditionalInvolvedPartyFormValid");
    }
    
    this.resetAdditionalInvolvedPartyForm();

    this.vendorService.updateData(this.formdata);
    this.router.navigate(['involvedParties']);
    this.progressBarService.sendData(true);
  }

  valueChange(data: any) {
    if (data.name == 'isAnotherExternalInvolvedParty') {
      this.isExternalReferringParty = data.value.srcElement.value;
    }

    if(data.name == 'isAnotherInvolvedParty') {
      this.addAnotherInvolvedParty = this.anotherInvolvedPartyControl.find((x: { name: string; }) => x.name == "isAnotherInvolvedParty").value;
    }

    if(data.name == 'additionalInvolvedType' || data.name == 'editInvolvedType') {
      if(data.name == 'editInvolvedType') {
        this.involvedPartyControl.find((x: { name: string; }) => x.name == "additionalInvolvedType").value = this.editInvolvedPartyControl.find((x: { name: string; }) => x.name == "editInvolvedType").value;
      }
      let selectedPartyId = this.involvedPartyControl.find((x: { name: string; }) => x.name == "additionalInvolvedType").value;
      this.formdata.involvedParties.controls.find((x: { name: string; }) => x.name == "additionalInvolvedType").value = selectedPartyId;
      this.vendorService.getInvolvedPartyById(selectedPartyId, this.payorkey).subscribe((party) => {
        let profileMasterTypeKeyValue = party.ProfileMasterTypeKey;
        let subjectTypeKeyValue = party.SubjectTypeKey;
        
        if (profileMasterTypeKeyValue === 1) {
          this.formdata.providerDetails.controls.forEach((element: any) => {
            element.value = '';
          });
        }
        else if (profileMasterTypeKeyValue === 2) {
          this.formdata.memberDetails.controls.forEach((element: any) => {
            element.value = '';
          });
        }
        else if (profileMasterTypeKeyValue === 3) {
          this.formdata.nonEnumeratedProviderDetails.controls.forEach((element: any) => {
            element.value = '';
          });
        }
        else if (profileMasterTypeKeyValue === 4) {
          this.formdata.nonEnumeratedOrganizationDetails.controls.forEach((element: any) => {
            element.value = '';
          });
        }
        else if (profileMasterTypeKeyValue === 5) {
          this.formdata.nonEnumeratedIndividualDetails.controls.forEach((element: any) => {
            element.value = '';
          });
        }
        setTimeout(() => {
          this.profileMasterTypeKey = profileMasterTypeKeyValue;
          this.subjecyTypeId = subjectTypeKeyValue;
          this.cdref.detectChanges();
        });
        this.vendorService.updateData(this.formdata);
      });

      this.involvedPartyTypeSelected = true;
    }

    this.vendorService.updateData(this.formdata);
    this.formValidate();
  }

  openInstruction() {

    const result = this.modalService.open(InstructionsComponent, { size: 'lg', ariaLabelledBy: 'Instructions' });
    result.componentInstance.name = this.instructionText;
  }

  formValidate() {
    let isValidForm = false;
    if (this.addAnotherInvolvedParty == 'Yes') {
      if (this.isExternalReferringParty == 'Yes') {
          if (this.involvedPartyFormPart.valid && this.additionalInvolvedPartyFormPart.valid) {
            isValidForm = true;
          } else {
            isValidForm = false;
          }
      } else if (this.isExternalReferringParty == "No") {
        if (this.involvedPartyFormPart.valid) {
          isValidForm = true;
        } else {
          isValidForm = false;
        }
      }
    }
    else if (this.addAnotherInvolvedParty == 'No') {
        isValidForm = true;
    }

    this.isFormsValid = isValidForm;
    this.cdref.detectChanges();
    if(this.isFormsValid) {
      window.sessionStorage.setItem("AdditionalInvolvedPartyFormValid", "true");
    }
    else {
      window.sessionStorage.removeItem("AdditionalInvolvedPartyFormValid");
    }
  }

  formValidateWithChild() {
    let isValidForm = false;
    if (this.addAnotherInvolvedParty == 'Yes') {
      if (this.isExternalReferringParty == 'Yes') {
          if (this.involvedPartyFormPart.valid && this.additionalInvolvedPartyFormPart.valid && this.childFormValid) {
            isValidForm = true;
          } else {
            isValidForm = false;
          }
      } else if (this.isExternalReferringParty == "No") {
        if (this.involvedPartyFormPart.valid && this.childFormValid) {
          isValidForm = true;
        } else {
          isValidForm = false;
        }
      }
    }
    else if (this.addAnotherInvolvedParty == 'No') {
        isValidForm = true;
    }

    if(this.showSaveButton && isValidForm) {
      isValidForm = this.childFormChanged;
    }
    this.isFormsValid = isValidForm;
    this.cdref.detectChanges();
    if(this.isFormsValid) {
      window.sessionStorage.setItem("AdditionalInvolvedPartyFormValid", "true");
    }
    else {
      window.sessionStorage.removeItem("AdditionalInvolvedPartyFormValid");
    }
  }

  addInvolvedParty(isEditForm: boolean) {

    if(isEditForm) {
      this.showSaveButton = false;
    }
    
    this.isFormsValid = false;
    let formControlDetails: any;
    let firstName = '';
    let middleName = '';
    let lastName = '';
    const selectedPartyId = parseInt(this.involvedPartyControl[0].value);
    if (this.profileMasterTypeKey === 1) {
      formControlDetails = JSON.parse(JSON.stringify(this.formdata.providerDetails));
      firstName = formControlDetails.controls.find((x: { name: any; }) => x.name == "pFirstName").value;
      middleName = formControlDetails.controls.find((x: { name: any; }) => x.name == "pMiddleName").value;
      lastName = formControlDetails.controls.find((x: { name: any; }) => x.name == "pLastName").value;
    }
    else if (this.profileMasterTypeKey === 2) {
      formControlDetails = JSON.parse(JSON.stringify(this.formdata.memberDetails));
      firstName = formControlDetails.controls.find((x: { name: any; }) => x.name == "mFirstName").value;
      middleName = formControlDetails.controls.find((x: { name: any; }) => x.name == "mMiddleName").value;
      lastName = formControlDetails.controls.find((x: { name: any; }) => x.name == "mLastName").value;
    }
    else if (this.profileMasterTypeKey === 3) {
      formControlDetails = JSON.parse(JSON.stringify(this.formdata.nonEnumeratedProviderDetails));
      firstName = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepFirstName").value;
      middleName = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepMiddleName").value;
      lastName = formControlDetails.controls.find((x: { name: any; }) => x.name == "nepLastName").value;
    }
    else if (this.profileMasterTypeKey === 4) {
      formControlDetails = JSON.parse(JSON.stringify(this.formdata.nonEnumeratedOrganizationDetails));
      firstName = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoContactFirstName").value;
      middleName = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoContactMiddleName").value;
      lastName = formControlDetails.controls.find((x: { name: any; }) => x.name == "neoContactLastName").value;
    }
    else if (this.profileMasterTypeKey === 5) {
      formControlDetails = JSON.parse(JSON.stringify(this.formdata.nonEnumeratedIndividualDetails));
      firstName = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiFirstName").value;
      middleName = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiMiddleName").value;
      lastName = formControlDetails.controls.find((x: { name: any; }) => x.name == "neiLastName").value;
    }
    
    let involvedPartyObj = {
      Id: 0,
      isPrimary: false,
      subjectType: this.involvedPartyControl[0].options.find((option: any) =>  option.value == selectedPartyId)?.key,
      subjectTypeKey: this.subjecyTypeId,
      involvedPartyId: selectedPartyId,
      organization: (lastName == ''? '' : lastName + ', ' ) + firstName +' ' + (middleName?? ''),
      isExternalReferal: this.isExternalReferringParty == 'Yes',
      formControlDetails: formControlDetails,
      profileMasterTypeKey: this.profileMasterTypeKey,
      externalReferalReport: this.isExternalReferringParty == 'Yes' ? this.additionalInvolvedPartyControl[0].value : '',
      externalReferalAddInfo: this.isExternalReferringParty == 'Yes' ? this.additionalInvolvedPartyControl[1].value : ''
    };
    if(isEditForm) {

       let listData = this.formdata.involvedParties.data.map((item: any) => {
        if(item.isPrimary && item.Id == this.currentInvolvedPartyTypeData.Id) {
          this.formdata.witnessDetails.controls.find( (x: { name: string }) => x.name == "involvedType" ).value = selectedPartyId;
          this.formdata.extenalReferall.controls.find((x: { name: string; }) => x.name == "isExternalReferal").value = this.isExternalReferringParty;
          involvedPartyObj.isPrimary = true;
          let tempId = item.Id;
          item = involvedPartyObj;
          item.Id = tempId;
        }
        else if(item.Id == this.currentInvolvedPartyTypeData.Id) {
          let tempId = item.Id;
          item = involvedPartyObj;
          item.Id = tempId;
        }

        return item;
      });

      this.formdata.involvedParties.data = listData;
    }
    else {
      involvedPartyObj.Id = this.involvedPartyList.length + 2;
      this.formdata.involvedParties.data.push(involvedPartyObj);
    }
    this.vendorService.updateData(this.formdata);
    this.resetAdditionalInvolvedPartyForm();
    window.location.reload();
  }

  resetAdditionalInvolvedPartyForm() {
    if (this.profileMasterTypeKey === 1) {
      this.formdata.providerDetails = JSON.parse(JSON.stringify(this.providerDetails));
    }
    else if (this.profileMasterTypeKey === 2) {
      this.formdata.memberDetails = JSON.parse(JSON.stringify(this.memberDetails));
    }
    else if (this.profileMasterTypeKey === 3) {
      this.formdata.nonEnumeratedProviderDetails = JSON.parse(JSON.stringify(this.nonEnumeratedProviderDetails));
    }
    else if (this.profileMasterTypeKey === 4) {
      this.formdata.nonEnumeratedOrganizationDetails = JSON.parse(JSON.stringify(this.nonEnumeratedOrganizationDetails));
    }
    else if (this.profileMasterTypeKey === 5) {
      this.formdata.nonEnumeratedIndividualDetails = JSON.parse(JSON.stringify(this.nonEnumeratedIndividualDetails));
    }

    let resetInvolvedParties = JSON.parse(JSON.stringify(this.resetInvolvedPartiesControls));
    resetInvolvedParties.forEach((element: any) => {
      element.value = '';
    });
    this.formdata.involvedParties.controls = JSON.parse(JSON.stringify(resetInvolvedParties));
    this.anotherInvolvedPartyControl = this.formdata.involvedParties.controls.slice(0, 1);
    this.primaryInvolveParty = this.formdata.involvedParties.data.find((item: any) => item.isPrimary == true);
    this.involvedPartyList = this.formdata.involvedParties.data.filter((item: any) => item.isPrimary == false);
    this.involvedPartyControl = this.formdata.involvedParties.controls.slice(1,2);
    this.externalInvolvedPartyControl = this.formdata.involvedParties.controls.slice(2,3);
    this.additionalInvolvedPartyControl = this.formdata.involvedParties.controls.slice(3,5);
    this.isExternalReferringParty = '';
    this.addAnotherInvolvedParty = '';
    this.involvedPartyTypeSelected = false;
    this.vendorService.updateData(this.formdata);
  }

  formValidationEvent(data: any) {
    this.childFormValid = data.isValid;
    this.childFormChanged = data.isChanged;
    this.formValidateWithChild();
  }

  submitInvolvedParties() {
    if(this.isFormsValid) {
      window.sessionStorage.setItem("AdditionalInvolvedPartyFormValid", "true");
    }
    else {
      window.sessionStorage.removeItem("AdditionalInvolvedPartyFormValid");
    }

    sessionStorage.setItem('activeformdata', JSON.stringify(this.formdata));
    this.router.navigate(['questions']);
  }
  
  onDeleteAdditionalInvolvedParty(object: any) {
    const initialState = {
        title: 'Delete Subject',
        message: 'Do you wish to proceed with deleting the subject? Clicking “Yes” will permanently remove all information entered and delete the subject entry.',
        autoClose: false,
        cancelString: 'Cancel',
        yes: 'Yes',
    };
    let modalRef: BsModalRef = this.modalBSService.show(ConfirmationComponent, {
        animated: false,
        ignoreBackdropClick: true,
        //class: 'modal-dialog modal-dialog-scrollable modal-dialog-centered modal-lg',
        initialState,
        keyboard: false
    });

    modalRef.content.onClose.subscribe((isConfirmed: any) => {
      if(isConfirmed) {
        this.formdata.involvedParties.data = this.formdata.involvedParties.data.filter( (item: any) => {
          return item.Id != object.Id;
        });
        let listData = this.formdata.involvedParties.data.map( (item: any, index: number) => {
          item.Id = index + 1;
          return item;
        });
        this.formdata.involvedParties.data = listData;
        this.involvedPartyList = this.formdata.involvedParties.data.filter((item: any) => item.isPrimary == false);
        this.vendorService.updateData(this.formdata);
      }
    });
    
  }
  
  onEditAdditionalInvolvedParty(object: any) {
    this.currentInvolvedPartyTypeData = JSON.parse(JSON.stringify(object));
    this.showSaveButton = true;
    this.addAnotherInvolvedParty = 'Yes';
    this.anotherInvolvedPartyControl.find((x: { name: string; }) => x.name == "isAnotherInvolvedParty").value = this.addAnotherInvolvedParty;

    this.vendorService.getInvolvedPartiesLookup(this.payorkey).subscribe((result) => {

      let selectedpartyObj = this.formdata.involvedParties.data.find( (item: any) => {
        return item.Id == object.Id;
      });
      if (selectedpartyObj) {
        this.isExternalReferringParty = selectedpartyObj.isExternalReferal ? 'Yes' : 'No';
        this.externalInvolvedPartyControl.find((x: { name: string; }) => x.name == "isAnotherExternalInvolvedParty").value = this.isExternalReferringParty;
        let selectedparty = result.find(x => x.Id == selectedpartyObj.involvedPartyId);
        this.involvedPartyControl.find((x: { name: string; }) => x.name == "additionalInvolvedType").value = selectedpartyObj.involvedPartyId ?? '';
        this.editInvolvedPartyControl.find((x: { name: string; }) => x.name == "editInvolvedType").value = selectedpartyObj.involvedPartyId ?? '';
        this.formdata.involvedParties.controls.find((x: { name: string; }) => x.name == "additionalInvolvedType").value = selectedpartyObj.involvedPartyId ?? '';
        this.involvedPartyTypeSelected = true;
        this.additionalInvolvedPartyControl.find((x: { name: string; }) => x.name == "externalReferalReport").value = selectedpartyObj.externalReferalReport ?? '';
        this.additionalInvolvedPartyControl.find((x: { name: string; }) => x.name == "externalReferalAddInfo").value = selectedpartyObj.externalReferalAddInfo ?? '';
        if (selectedparty) {
          this.profileMasterTypeKey = selectedparty.ProfileMasterTypeKey;
          this.subjecyTypeId = selectedparty.SubjectTypeKey;
          if(selectedpartyObj.formControlDetails != null && selectedpartyObj.formControlDetails.controls != null && selectedpartyObj.formControlDetails.controls.length > 0) {
            let involvedPartyDetails = JSON.parse(JSON.stringify(selectedpartyObj.formControlDetails));
            if (this.profileMasterTypeKey === 1) {
              this.formdata.providerDetails = JSON.parse(JSON.stringify(involvedPartyDetails));
            }
            else if (this.profileMasterTypeKey === 2) {
              this.formdata.memberDetails = JSON.parse(JSON.stringify(involvedPartyDetails));
            }
            else if (this.profileMasterTypeKey === 3) {
              this.formdata.nonEnumeratedProviderDetails = JSON.parse(JSON.stringify(involvedPartyDetails));
            }
            else if (this.profileMasterTypeKey === 4) {
              this.formdata.nonEnumeratedOrganizationDetails = JSON.parse(JSON.stringify(involvedPartyDetails));
            }
            else if (this.profileMasterTypeKey === 5) {
              this.formdata.nonEnumeratedIndividualDetails = JSON.parse(JSON.stringify(involvedPartyDetails));
            }
          }

          this.vendorService.updateData(this.formdata);
          this.cdref.detectChanges();
        }
      }
      
      setTimeout(() => {
        this.cdref.detectChanges();
        this.vendorService.updateData(this.formdata);
      });
    });
  
  }
  
  ngOnDestroy(): void {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }

}
